import { AppLanguage } from "../types/index.js";

const LOCALE_BY_LANGUAGE: Record<AppLanguage, string> = {
	en: "en-US",
	es: "es-ES",
	fr: "fr-FR",
	"pt-BR": "pt-BR",
};

const SUPPORTED_LANGUAGES: readonly AppLanguage[] = Object.values(AppLanguage);

export const DEFAULT_LOCALE = LOCALE_BY_LANGUAGE.en;

function getBaseLanguage(tag: string): string {
	return tag.split("-")[0]?.toLowerCase() ?? "";
}

export function resolveLocale(language: string | null | undefined): string {
	if (!language) return DEFAULT_LOCALE;
	const tag = language.trim();
	if (!tag) return DEFAULT_LOCALE;
	const base = getBaseLanguage(tag);
	const supported = SUPPORTED_LANGUAGES.find((candidate) => getBaseLanguage(candidate) === base);
	if (!supported) return DEFAULT_LOCALE;
	return tag.includes("-") ? tag : LOCALE_BY_LANGUAGE[supported];
}
